module.exports = __webpack_public_path__ + "img/ED7F04_FCD60E_7E2D04_B73E04-256px.334820f4.png";